import parsePhoneNumber from 'libphonenumber-js';

export const formatPhoneNumber = (phone: string) => {
  const phoneNumber = parsePhoneNumber('+' + phone);

  return phoneNumber.formatInternational();
};
